export const getCurrentDataRequestId = () => {
  return window.location.pathname.substring(1).split('/')[1];
};
